import React from 'react'
import Drawer from '@material-ui/core/Drawer'

const CustomDrawer = ({ className, children, anchor, toggleDrawer, open, ...props }) => {
    return (
        <Drawer
            anchor={anchor}
            open={open}
            onClose={toggleDrawer}
            className={className ? className : 'custom-drawer'}
        >
            <a className="close-drawer" onClick={toggleDrawer}>
                <i className="material-icons">close</i>
            </a>
            {children}
        </Drawer>
    )
}

export default CustomDrawer
